import {
  faClock as lightClock,
  faFloppyDisk as lightFloppyDisk,
  faFolder as lightFolder,
  faMobile as lightMobile,
} from "@awesome.me/kit-81e892e0ca/icons/classic/light";
import {
  faAngleDown as regularAngleDown,
  faAngleRight as regularAngleRight,
  faAngleUp as regularAngleUp,
  faArrowsSplitUpAndLeft as regularArrowsSplitUpAndLeft,
  faArrowDown as regularArrowDown,
  faArrowLeft as regularArrowLeft,
  faArrowRight as regularArrowRight,
  faArrowsRepeat as regularArrowsRepeat,
  faArrowsRotate as regularArrowsRotate,
  faArrowUp as regularArrowUp,
  faAsterisk as regularAsterisk,
  faBell as regularBell,
  faBold as regularBold,
  faBooks as regularBooks,
  faCalendar as regularCalendar,
  faCheck as regularCheck,
  faCheckCircle as regularCheckCircle,
  faChevronLeft as regularChevronLeft,
  faChevronRight as regularChevronRight,
  faCircleExclamation as regularCircleExclamation,
  faCircleInfo as regularCircleInfo,
  faClockRotateLeft as regularClockRotateLeft,
  faComment as regularComment,
  faCommentCheck as regularCommentCheck,
  faCopy as regularCopy,
  faEnvelope as regularEnvelope,
  faFilePen as regularFilePen,
  faFilter as regularFilter,
  faFolder as regularFolder,
  faGear as regularGear,
  faGlobe as regularGlobe,
  faGripDotsVertical as regularGripDotsVertical,
  faItalic as regularItalic,
  faLink as regularLink,
  faMagnifyingGlass as regularMagnifyingGlass,
  faMinus as regularMinus,
  faPaperPlaneTop as regularPlaneTop,
  faPencil as regularPencil,
  faPlus as regularPlus,
  faPrint as regularPrint,
  faQrcode as regularQrcode,
  faRepeat as regularRepeat,
  faShare as regularShare,
  faSparkles as regularSparkles,
  faSpinner as regularSpinner,
  faStar as regularStar,
  faText as regularText,
  faTrashCan as regularTrashCan,
  faXmark as regularXmark,
  faXmarkLarge as regularXmarkLarge,
} from "@awesome.me/kit-81e892e0ca/icons/classic/regular";
import {
  faArrowsSplitUpAndLeft as solidArrowsSplitUpAndLeft,
  faBell as solidBell,
  faCalendar as solidCalendar,
  faCalendarClock as solidCalendarClock,
  faCheck as solidCheck,
  faChevronRight as solidChevronRight,
  faCircleCheck as solidCircleCheck,
  faCircleExclamation as solidCircleExclamation,
  faCircleInfo as solidCircleInfo,
  faComment as solidComment,
  faCommentCheck as solidCommentCheck,
  faContactCard as solidContactCard,
  faCopy as solidCopy,
  faCreditCard as solidCreditCard,
  faDiamondExclamation as solidDiamondExclamation,
  faDollarSign as solidDollarSign,
  faEllipsis as solidEllipsis,
  faEnvelope as solidEnvelope,
  faFileArrowUp as solidFileArrowUp,
  faFloppyDisk as solidFloppyDisk,
  faFolder as solidFolder,
  faGear as solidGear,
  faGlobe as solidGlobe,
  faGripDotsVertical as solidGripDotsVertical,
  faHashtag as solidHashtag,
  faInputText as solidInputText,
  faList as solidList,
  faLink as solidLink,
  faListRadio as solidListRadio,
  faLocationDot as solidLocationDot,
  faMagnifyingGlass as solidMagnifyingGlass,
  faMemo as solidMemo,
  faMinus as solidMinus,
  faNetworkWired as solidNetworkWired,
  faObjectGroup as solidObjectGroup,
  faPaperPlaneTop as solidPaperPlaneTop,
  faPencil as solidPencil,
  faPenToSquare as solidPenToSquare,
  faPhone as solidPhone,
  faPlus as solidPlus,
  faQrcode as solidQrcode,
  faSave as solidSave,
  faShare as solidShare,
  faShieldCheck as solidShieldCheck,
  faSpinner as solidSpinner,
  faSquareA as solidSquareA,
  faSquareFull as solidSquareFull,
  faSquareUp as solidSquareUp,
  faStar as solidStar,
  faTrashCan as solidTrashCan,
  faTriangleExclamation as solidTriangleExclamation,
  faUpRightFromSquare as solidUpRightFromSquare,
  faXmark as solidXmark,
  faXmarkLarge as solidXmarkLarge,
} from "@awesome.me/kit-81e892e0ca/icons/classic/solid";

export const availableIcons = {
  lightClock,
  lightFloppyDisk,
  lightFolder,
  lightMobile,
  regularAngleDown,
  regularAngleRight,
  regularAngleUp,
  regularArrowsSplitUpAndLeft,
  regularArrowDown,
  regularArrowLeft,
  regularArrowRight,
  regularArrowsRepeat,
  regularArrowsRotate,
  regularArrowUp,
  regularAsterisk,
  regularBell,
  regularBold,
  regularBooks,
  regularCalendar,
  regularCheck,
  regularCheckCircle,
  regularChevronLeft,
  regularChevronRight,
  regularCircleExclamation,
  regularCircleInfo,
  regularClockRotateLeft,
  regularComment,
  regularCommentCheck,
  regularCopy,
  regularEnvelope,
  regularFilePen,
  regularFilter,
  regularFolder,
  regularGear,
  regularGlobe,
  regularGripDotsVertical,
  regularItalic,
  regularLink,
  regularMagnifyingGlass,
  regularMinus,
  regularPencil,
  regularPlaneTop,
  regularPlus,
  regularPrint,
  regularQrcode,
  regularRepeat,
  regularShare,
  regularSparkles,
  regularSpinner,
  regularStar,
  regularText,
  regularTrashCan,
  regularXmark,
  regularXmarkLarge,
  solidArrowsSplitUpAndLeft,
  solidBell,
  solidCalendar,
  solidCalendarClock,
  solidCheck,
  solidChevronRight,
  solidCircleCheck,
  solidCircleExclamation,
  solidCircleInfo,
  solidComment,
  solidCommentCheck,
  solidContactCard,
  solidCopy,
  solidCreditCard,
  solidDiamondExclamation,
  solidDollarSign,
  solidEllipsis,
  solidEnvelope,
  solidFileArrowUp,
  solidFloppyDisk,
  solidFolder,
  solidGear,
  solidGlobe,
  solidGripDotsVertical,
  solidHashtag,
  solidInputText,
  solidLink,
  solidList,
  solidListRadio,
  solidLocationDot,
  solidMagnifyingGlass,
  solidMemo,
  solidMinus,
  solidNetworkWired,
  solidObjectGroup,
  solidPaperPlaneTop,
  solidPencil,
  solidPenToSquare,
  solidPhone,
  solidPlus,
  solidQrcode,
  solidSave,
  solidShare,
  solidShieldCheck,
  solidSpinner,
  solidSquareA,
  solidSquareFull,
  solidSquareUp,
  solidStar,
  solidTrashCan,
  solidTriangleExclamation,
  solidUpRightFromSquare,
  solidXmark,
  solidXmarkLarge,
};

export type IconName = keyof typeof availableIcons | "archie";
